import axios from 'axios'
import library from '../../../utils/Library'

export const getDataUserOrganization = async (organizationUserId) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('organization') +
    '/getUserDataOrganizationCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      organizationUserId: organizationUserId
    }
  })
}
